import { Injectable, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EpdkLoadingDialogComponent } from './loading-dialog.component';

/**
 * WARNING: This service SHOULD NOT be used when dialogs are opened shortly after(<500ms) open() is called because open() is asynchronous and will overwrite other active dialogs when it creates its own.
 * TODO: Refactor open and close to use an observable to notify listeners of when it is done opening and closing it's own MatDialog 
 */
@Injectable({ providedIn: 'root' })
export class FullscreenLoadingOverlayService {

  private _currentDialogRef?: MatDialogRef<EpdkLoadingDialogComponent>;

  constructor(private _dialog: MatDialog, private _ngZone: NgZone) { }

  open(): void {
    if (this._currentDialogRef) {
      return;
    }

    this._ngZone.run(() => {
      this._currentDialogRef = this._dialog.open(EpdkLoadingDialogComponent, {
        width: '96px',
        disableClose: true,
        restoreFocus: false
      });
    });
  }

  close() {
    if (!this._currentDialogRef) {
      return;
    }

    this._ngZone.run(() => {
      this._currentDialogRef.close();

      this._currentDialogRef = null;
    });
  }
}